"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var hiEgg = {
    name: "hi",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["h", "i"],
        captureOnInputs: false
    },
    onStart: function () {
        var data = "https://weichiachang.github.io/easter-eggs-mobile/images/hi.gif";
        var shock = document.createElement("div");
        var img = new Image();
        img.src = data;
        img.style.width = "300px";
        img.style.height = "300px";
        img.style.transition = "1s all";
        img.style.position = "fixed";
        img.style.left = "calc(50% - 150px)";
        img.style.bottom = "-100px";
        img.style.zIndex = "999999";
        document.body.appendChild(img);
        window.setTimeout(function () {
            img.style.bottom = "-50px";
        }, 30);
        window.setTimeout(function () {
            img.style.bottom = "-300px";
        }, 4300);
        window.setTimeout(function () {
            img.parentNode.removeChild(img);
        }, 5400);
    },
};
exports.default = hiEgg;
